import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      PERSONAL_INFORMATION: "Personlig informasjon",
      EDIT_BUTTON: "Rediger",
      PASSWORD: "Passord",
      CURRENT_PASSWORD: "Nåværende passord",
      CONSENTS: "Samtykker",
      CONSENTS_DESCRIPTION:
        "Slik bruker vi din data for å forbedre din matopplevelse.",
      DELETE_ACCOUNT: "Slett konto",
    },

    se: {
      PERSONAL_INFORMATION: "Personuppgifter",
      EDIT_BUTTON: "Redigera",
      PASSWORD: "Lösenord",
      CURRENT_PASSWORD: "Nuvarande lösenord",
      CONSENTS: "Medgivanden",
      CONSENTS_DESCRIPTION:
        "Hur vi använder dina uppgifter för att ge dig en bättre matupplevelse.",
      DELETE_ACCOUNT: "Radera konto",
    },

    dk: {
      PERSONAL_INFORMATION: "Personlig information",
      EDIT_BUTTON: "Rediger",
      PASSWORD: "Kodeord",
      CURRENT_PASSWORD: "Nuværende kodeord",
      CONSENTS: "Mine tilladelser",
      CONSENTS_DESCRIPTION:
        "Sådan bruger vi dine data for at forbedre din brugeroplevelse.",

      DELETE_ACCOUNT: "Slet konto",
    },
  } as const
)[language];
